import * as React from "react";
import {useEffect, useContext} from "react";
import {Community} from "../queries/community";
import {UserCommunitiesContext} from "../context/userCommunitiesContext";
import {useUserInfo} from "../../userInfo/hooks/useUserInfo";

export const useUserCommunities = () => {
    const {state, dispatch} = useContext(UserCommunitiesContext);
    const {profil} = useUserInfo();
    useEffect(() => {
        profil !== undefined && state === undefined && Community.getUserCommunities(profil.userId).then((response) => dispatch({type: "initUserCommunities",payload:response}))
    },[profil])

    return {list:state}
}
